import React from 'react';

const Section$ = () => <div style={{textIndent: '2em'}}>
        <div style={{textAlign: 'center'}}>
            <br/>
            <h1 name="0-11" className="point" id="0-11">第十二章 质检管理制度</h1></div>
        <div style={{textIndent: '2em'}}>
            <br/>
            <h2 name="0-11-0" className="point" id="0-11-0">一、车辆竣工检验流程及标准</h2>
            <h3 name="0-11-0-0" className="point" id="0-11-0-0">1、车辆竣工检验流程</h3>
            <h3 name="0-11-0-1" className="point" id="0-11-0-1">2、车辆竣工具体标准</h3>
            <p>1、维修技师在完成修理后及后续整理工作后进行。自检的主要内容包括:根据维修工单的作业内容,逐项检查是否达到技术标准。自检完毕,维修技师在维修工单技师栏填写自己名字。没填写技师名字，扣除100积分。</p>
            <p>2、车间领班对车间内的维修质量负责。在主修技师自检完成后,领班应按规定对所完成的维修项目进行质检,并核对是否所有维修项目和操作内容均已完成;当发现问题时,必须采取相应措施进行纠正;检验的结果应反馈给维修技师,以提高维修技师的技术水平,避免同一问题的重复发生;完成质检后,班组长应当在维修工单技师签字后面签字确认，如有增加项目应在增项技师签字的下面签字确认,然后将工单、客户自费更换的配件、钥匙交接给前台客户代表。如果维修技师维修操作有问题或保修项目遗漏，并且车间领班没有检查出，扣除车间领班200积分。</p>
            <p>3、前台客户代表在车间领班检验合格后,再对车辆的维修项目和质量进行最终核对,
                交车前检查车况(油液面及颜色外观质检)，必要时路试,同时对完工车辆的清洁状况进行检查;做好最终检验记录,并签字。未经车间领班质检的车辆,前台客户代表可以拒绝接车并现场要求维修质检。如前台擅自在没有经过车间领班质检的情况签字，扣除前台300积分。</p>
            <p>对总成大修和事故车修理的,应向客户解释注意事项和保修条款。重要、安全性能的修理、返修等,应优先检验。如果没有向客户解释直接交车，扣除前台500积分。</p>
            <p>4、如质量检验未通过，由车间领班根据实际问题进行纠正，或由维修技师返修。</p>
            <p>5、由前台引导客户至财务部进行维修结算，并在结算单上签字确认。确认后，前台将车辆钥匙及相关物品交付客户并礼貌用语，如客户没有结账前台擅自交车，扣除500积分。</p>
            <h3 name="0-11-0-2" className="point" id="0-11-0-2">3、未通过质检车辆的处理环节</h3>
            <p>维修检验不合格指各级检验中发生的维修质量不合格情况。自检和检验发生的不合格问题由各班组班组长负责自行采取相应的纠正措施。但对于由于技术水平、配件、维修检测设备原因,班组不能解决的,应当及时报告车间领班。</p>

            <h3 name="0-11-0-3" className="point" id="0-11-0-3">4、内部返修的处理环节</h3>
            <p>检验中发现的不合格情况,车间领班应当做好记录,并把不合格车辆返回原承修班组重新维修,告知检验发现的问题和做好“检验不合格的记录”，待维修完成重新按照车间完修检验流程进行质量检验。合格后交付前台。</p>

            <h3 name="0-11-0-4" className="point" id="0-11-0-4">5、监管</h3>
            <p>1、因操作失误和工作疏忽（装配错误、调整错误）造成的返修/返工，损失在1000元以下的，扣除100积分。</p>
            <p>2、维修事故，损失在1万元以下的，考核当月绩效的10%，损失在1万-3万的，考核当月绩效30%；损失在3万以上的，考核当月绩效40%。</p>
            <h3 name="0-11-1" className="point" id="0-11-1">二、新车交车检验流程及标准</h3>

            <h3 name="0-11-1-0" className="point" id="0-11-1-0">1、接车检查</h3>
            <p>1、车辆到达预定交车地点（公司内或客户指定的地址）后，首先要求送车驾驶员将车辆清洗干净，由验车人员（公司内由销售支持岗位负责，非公司内由销售人员负责）及车辆驾驶员共同对车辆进行检查，检查项目如下：</p>
            <p>2、依照车辆《货物进口证明书》《随车检验单》《合格证》核对车辆底盘号、发动机号、车身颜色是否一致。（进口、国产卡车不同单据）</p>
            <p>3、车辆外观：检查车身平整度是否有凹凸、漆面是否完好、灯罩是否完好有无破损及裂纹。</p>
            <p>4、检查车辆的灯光及车辆使用功能：检查前近光灯、远光灯、转向灯、前后雾灯、倒车灯、倒车蜂鸣器、刹车灯、示宽灯等是否可以正常开启和关闭；车辆使用功能的检查：检查车辆玻璃升降功能、电动调节后视镜（如有）、车辆音响、室内灯光控制、座椅的调节、仪表板是否正常显示。</p>
            <p>5、随车附件的检查，因车辆配置的不同，按厂家提供的车辆配置表进行检查。车辆检查完毕时完成《车辆交接单》（后附），要求检验人员及送车驾驶员共同在《车辆交接单》签字确认，对于车辆破损及损坏部位进行拍照，最后将问题车辆的《车辆交接单》及破损照片以邮件的形式报相应予品牌厂家销售部门进行索赔。</p>
            <h3 name="0-11-1-1" className="point" id="0-11-1-1">2、新车交车检验流程</h3>
            <h4>1、交车前准备</h4>
            <p>1.1、确定车辆交付日期，提前3日通知客户提车日期,同时通知所属服务经理。</p>
            <p>1.2、完成交车前检查</p>
            <p>1.3、清洗车辆</p>
            <p>1.4、检查车辆外观</p>
            <p>1.5、随车附件及清单</p>
            <p>1.6、车辆文件是否齐全</p>
            <p>1.7、申请驾驶培训</p>
            <h4>2、交车</h4>
            <p>2.1、按照斯堪尼亚《交车清单》逐项向客户介绍各项注意事项和说明</p>
            <p>2.2、陪同客户检查车辆外观</p>
            <p>2.3、检查灯光</p>
            <p>2.4、检查仪表是否正常，并讲解使用方法</p>
            <p>2.5、检查油液位，并讲解各种油液的加注标准</p>
            <p>2.6、清点随车附件</p>
            <p>2.7、签署交车文件（《交车清单》 《随车附件交接单》 《文件交接单》）</p>
            <p>2.8、介绍售后部门经理及配件经理</p>
            <p>2.9、客户、销售、售后三方车前合影留念</p>
            <h4>3、交车后</h4>
            <p>3.1、向索赔部门汇报交车情况,并更新发送《车辆信息交接表》给服务部、索赔部。</p>
            <p>3.2、驾驶培训（条件允许情况下，尽量安排交车当日进行驾驶培训）</p>
            <p>3.3、两周内回访客户，了解车辆使用情况</p>
            <p>3.4、约定跟车培训日期</p>
            <h3 name="0-11-1-2" className="point" id="0-11-1-2">3、交车过程中规范（以此基础建立交车清单并在交车过程中逐条向客户介绍或确认，参考SCANIA交车清单）</h3>
            <h3 name="0-11-2" className="point" id="0-11-2">三、配件出入库检验流程及标准</h3>
            <h3 name="0-11-2-0" className="point" id="0-11-2-0">1、配件入库检验流程</h3>

            <h3 name="0-11-2-1" className="point" id="0-11-2-1">2、配件出库检验流程</h3>

            <h3 name="0-11-2-2" className="point" id="0-11-2-2">3、配件出库标准</h3>
            <p>1.1、配件出库必须有前台开具的销售单或结算单，否则不予出库。擅自出库者扣除500积分。</p>
            <p>1.2、销售单或结算单交付库管员，库管员根据清单准备配件，确认无误后签字，将配件与单据一起交付前台。</p>
            <p>1.3、前台根据销售单或结算单与客户结账，结账后将有客户、前台、库管签字的销售单或结算单交付统计出怀远单。</p>
            <p>1.4、统计出完怀远单后将单据交付库管核对，库管核对无误后签字，完成出库。</p>
            <p>1.5、有发货要求的配件，库管要对配件进行打包，并确保打包后的配件防水、防损、防蛀、防漏，并跟进物流状态。如出现配件损坏，扣除库管500积分。</p>
            <p>1.6、所有使用配件单据、必须要有相关领导与库管的签字，否则单据视为无效单据。</p>
            <p>1.7、销售配件必须与客户确认完好，并经客户认可后方可出库。</p>
            <p>1.8、维修配件必须与维修人员确认配件完好，并且无使用问题后，方可出库。</p>

            <h3 name="0-11-3" className="point" id="0-11-3">四、客户意见／投诉处理管理制度</h3>
            <h3 name="0-11-3-0" className="point" id="0-11-3-0">1、目的</h3>
            <p>为规范客户投诉及需求的定义、分类及统计分析工作，强调以客户为中心，通过科学、系统的投诉及需求统计分析，达到完善服务内容、服务质量预警作用，实现客户满意度提升、切实提高公司内部质量管理水平及产品质量，特制定本制度。</p>
            <h3 name="0-11-3-1" className="point" id="0-11-3-1">2、客户投诉／需求的定义及具体内容</h3>
            <h4>1、定义</h4>
            <p>客户投诉：是客户对公司的产品售卖、产品质量问题，服务态度等各方面的原因，向公司反应情况、检举问题，并要求得到相应的补偿的一种手段。</p>
            <p>客户需求：是客户对公司非产品售卖问题、非产品质量问题、非服务过程以及非合同承诺的一种额外需求或因误会公司存在问题而提出的需求。</p>
            <h4>2、客户投诉区分</h4>
            <h4>3、按投诉／需求的性质分：有效投诉和需求（沟通性）投诉</h4>
            <p>3.1 客户有效投诉：是指由于产品售卖、设备故障、产品质量、服务质量、服务过程等公司未实现承诺，造成客户向公司提出不满意的表示。 </p>
            <p>3.1.1 客户对公司的服务质量、服务过程提出投诉</p>
            <p>3.1.2 客户对产品售卖、价格及折扣等问题提出投诉</p>
            <p>3.1.3 客户对公司的产品质量问题提出投诉</p>
            <p>3.2 客户需求：是指客户针对公司各项服务（基础服务、对客服务）所提出的咨询、需求及建议，以及由于非公司因素引发的客户不满（包括无效投诉、非正当客户需求）。</p>
            <p>3.3 求助型：客户有困难或问题需给予帮助解决的。</p>
            <p>3.4 咨询型：客户有问题或建议向公司联络的。</p>
            <p>3.5 发泄型：客户带有某种不满，误会等造成的内心不满，要求把问题得到解决的。</p>
            <h3 name="0-11-3-2" className="point" id="0-11-3-2">3、有效投诉的等级分类</h3>

            <h3 name="0-11-3-3" className="point" id="0-11-3-3">4、投诉处理程序</h3>
            <h4>1、客户咨询类：</h4>
            <p>投诉部门能直接解答的，当即解答，不能解答的录入【客户／投诉登记表】，立即同相关部门联系了解情况，在24小时内答复客户，在【客户意见／投诉登记表】记录答复结果。</p>

            <p>客户意见类：由接收部门录入【客户意见／投诉登记表】向部门主管或经理汇报、请示。需要回复的，要给客户承若一定回复期限，待领导作出批示后向答复建议被采用情况。</p>
            <h4>2、客户投诉类：</h4>
            <p>责任部门接到投诉后，要根据内容分类处理，要求责任部门有专人进行调查。</p>
            <p>服务类：经调查属实的按公司规章制度判定属于违规或工作失职，应将具体情况向本部门经理汇报，由部门经理进行当事人的处罚，按公司规章制度处理。</p>
            <p>销售类：属于信息不对称的、工作失误的、误导客户的等，造成客户投诉，一经查证，按公司规章制度对当事人进行处理，并使其立即纠正，同时根据实际情况及时整改。如造成公司重大经济损失的（以公司各项规章制度为标准），由当事人进行赔偿，立即开除处理，并向公安机关报案处理。</p>
            <p>会员类：属于客户自身问题或误解引起投诉的，应做好对客户的解释工作，消除误会。</p>
            <p>备注：每周一对客户投诉事件进行统计分析，在周会上汇报。</p>
            <h3 name="0-11-3-4" className="point" id="0-11-3-4">5、投诉处理规范</h3>
            <h4>1、投诉分析和改进</h4>
            <p>接诉所属部门对客户投诉情况进行分类统计，分析客户投诉与期望值，综合评价，提出整改方法，改进工作和服务策略，提高服务水平。</p>
            <h4>2、投诉处理期限要求</h4>
            <p>客户投诉处理期限不能超过3个工作日，特殊情况不能超过5个工作日。硬件方面投诉的，如短期内不能及时完善或整改的，向部门总经理处请示批示。</p>
            <h4>3、处理结果的反馈和归档</h4>
            <p>接诉部门在投诉处理完毕后，将处理结果反馈给投诉人。征求投诉人对处理结果的意见和建议。</p>
            <p>行政部门做好处理归档工作，资料保存一年，重要资料延期保存。</p>
            <h4>4、客户投诉处理管理要求</h4>
            <p>各部门必须做到投诉件件有落实，事事有回复，认真填写，妥善保存【客户意见／投诉登记表】各部门要对投诉处理过程进行总结与分析，找出问题根源，吸取经验教训并提出改进对策，防止同类事件的再度出现。</p>
            <h3 name="0-11-4" className="point" id="0-11-4">五、内部稽查管理细则</h3>
            <h4>一、目的</h4>
            <p>为推动公司各项业务顺利进行，各项规章制度、运作程序和作业标准有效实施，确保产品交期达成、质量目标达标和部门间流程衔接顺畅，提高工作效率，特制定《内部管控稽查制度》。</p>
            <h4>二、适用范围</h4>
            <p>集团公司各级管理人员和全体员工</p>
            <h3 name="0-11-4-0" className="point" id="0-11-4-0">1、稽查制度执行领导组成员、职责及权限</h3>
            <h4>1、稽查制度执行领导组</h4>
            <p>1.1 稽查总指挥：管理公司总经理</p>
            <p>稽查副总指挥：管理公司分管副总经理</p>
            <p>1.2 稽查执行小组：（统计部负责人不在时由分管副总确定）</p>
            <p>组长：统计部负责人</p>
            <p>副组长：销售业务代表（由销售副总指定）</p>
            <p>副组长：服务业务代表（由服务副总指定）</p>
            <p>小组成员：全公司科级以上干部（根据情况由稽查组长协调安排）</p>
            <p>1.3 稽查依据；</p>
            <p>所有管理制度（包括培训制度）</p>
            <p>管理程序；</p>
            <p>操作规范；</p>
            <p>员工手册。</p>
            <h4>2、稽查工作领导小组的职责</h4>
            <p>2.1 统计部负责人负责稽查小组整体工作部署及奖罚的核准；</p>
            <p>2.2 副组长协助组长处理稽查事务，具体负责相关部门绩效目标的稽查，相关部门运行程序的稽查及办公现场的稽查；</p>
            <p>2.3 各部门负责人对稽查工作的监督；</p>
            <p>2.4 本部门负责人不直接参加本部门的稽查事务；</p>
            <p>2.5 监督统计工作由统计部负责。</p>
            <h4>3、稽查小组的权限</h4>
            <p>3.1 对管理公司所有人员均由处罚权、监督权；</p>
            <p>3.2 稽查小组必须秉持公平、公正、公开的原则，并接受所有人员的监督。</p>
            <h4>4、稽查结果责任划分</h4>
            <p>4.1 直接罚款/扣分负责人</p>
            <p>4.2 同样的错误在同一部门/公司出现多次追究负责人、分管副总责任。</p>

            <h3 name="0-11-4-1" className="point" id="0-11-4-1">2、操作方法</h3>
            <p>1、由稽查组长带领稽查人员对各部门/公司进行不定时抽查；</p>
            <p>2、稽查时间每次由稽查组织通知稽查人员参加，稽查人员不得以任何借口推脱（如稽查成员不能参加，由稽查组长做好相关记录），并按管理制度进行考核；</p>
            <p>3、具体时间安排如下：</p>
            <p>每周由稽查组长组织二次稽查，组长、副组长必须参加，其它部门负责人由稽查组长在稽查前通知相关人员参加（原则是该部门人员不参加本部门的稽查）；
            </p>
            <p>4、稽查人员按稽查依据进行抽查，发现不合理现象根据相关制度立即给予处罚；</p>
            <p>5、稽查结束后统一召开碰头，汇总稽查结果由稽查组长交副总指挥、总指挥签署，签署之后立即公布；</p>
            <p>6、稽查的情况每次由稽查组长作好记录并存档，作为各级管理人员薪资调整和月度绩效考核的依据之一。</p>
            <h3 name="0-11-4-2" className="point" id="0-11-4-2">3、检查内容</h3>
            <h4>1、销售政策和销售定价的订立及审批稽查要点</h4>
            <p>1.1 客户信用金额的订立、审批、复核和修改；</p>
            <p>1.2 销售合同的订立和审批；</p>
            <p>1.3 订单处理和开票；</p>
            <p>1.4 车辆、配件发运；</p>
            <p>1.5 销售入账和应收账款；</p>
            <h4>2、采购与付款业务内部控制稽查要点</h4>
            <p>2.1 采购合同档案管理</p>
            <p>2.2 采购计划和采购合同的订立、审批和修改；</p>
            <p>2.3 采购程序</p>
            <p>2.4 应付账款的采购付款；</p>
            <p>2.5 采购对象（车辆或配件）的入库和退回。</p>
            <h4>3、库存内部控制稽查要点</h4>
            <p>3.1 采购对象的入库和退回；</p>
            <p>3.2 车辆/配件出库；</p>
            <p>3.3 库存账目和盘点</p>
            <p>3.4 报废件的管理</p>
            <h4>4、营销业务内部控制稽查要点</h4>
            <p>4.1 营销计划内部控制；</p>
            <p>4.2 营销活动内部控制。</p>
            <h4>5、人力资源内部控制稽查要点</h4>
            <p>5.1 招聘、晋升、调派、合同到期和中止；</p>
            <p>5.2 人员培训；</p>
            <p>5.3 绩效核算</p>
            <p>5.4 考勤和休息</p>
            <h4>6、办公现场稽查要点</h4>
            <p>6.1 安全</p>
            <p>6.1.1 有否不安全作业；</p>
            <p>6.1.2 消防设备是否到位；</p>
            <p>6.1.3 有否堵塞消防通道；</p>
            <p>6.1.4 电线有否裸露在外面；</p>
            <p>6.1.5 办公环境严禁吸烟。</p>
            <h4>6.2 违纪事项</h4>
            <p>6.2.1 有否穿拖鞋，不戴胸牌现象；</p>
            <p>6.2.2 上班时间有否嬉戏和打闹现象；</p>
            <p>6.2.3 玩手机、上网或做与工作无关的事情。</p>
            <h4>6.3 工作状态</h4>
            <p>6.3.1 是否按照生产计划内容安排生产；</p>
            <p>6.3.2 是否按照操作程序标准（维修手册、作业指导书或工艺性文件）作业；</p>
            <p>6.3.3 是否按照公司要求完工检查；</p>
            <p>6.3.4 是否按照公司要求提交各项单据、表格。</p>
            <h4>6.4 其他事项</h4>
            <p>6.4.1 员工投诉和员工反应；</p>
            <p>6.4.2 部门之间的沟通协调性；</p>
            <p>6.4.3 临时工作的配合性；</p>
            <p>6.4.4 对管理制度的执行力度。</p>
            <h3 name="0-11-4-3" className="point" id="0-11-4-3">4、稽查报告及整改</h3>
            <p>1、本制度所称的关键绩效指标的执行情况由稽查人员共同评价，并尽可能按照数据分析和定量评估；</p>
            <p>2、稽查过程中，稽查人员可以通过交谈、查阅文件记录、查看现场等方式开展稽查，稽查结果要在稽查明细表上列明，并与被稽查人员核实。被稽查部门要积极配合制度稽查工作，提供必要的稽查资源，包括人力、物力等。</p>
            <p>3、稽查结束后，稽查人员要出具稽查报告，列出不符合项，并责成相关部门进行整改，“稽查报告”经管理公司总经理和分管总经理批准后以通报的形式发被稽查部门并予以公示。</p>
            <p>4、被稽查部门在收到稽查通报后，要在两个工作日内制定整改计划，并报稽查小组备案。</p>
            <p>5、整改计划要详细制定实施步骤、达成目标、责任人和完成时间。整改计划原则上要在一个月内完成，超过一个月的要在计划中说明特殊理由。</p>
            <p>6、被稽查部门负责人要及时跟进本部门的问题整改情况，必须按整改要求在规定时间内完成全部整改项，整改进度跨月的，要在每月28日以前向稽查小组反馈月度完成情况。</p>
            <p>7、统计部要逐步将部门制度管理执行情况及稽查整改情况纳入绩效考核项目。</p>
            <h3 name="0-11-4-4" className="point" id="0-11-4-4">5、考核细则</h3>
            <p>1、依据制定本制度的目的，对稽查中发现的效率高和延误交期情况，视情进行奖励和处罚；</p>
            <p>2、另外对制度稽查中出现下列情况的，给予100-500分的考核：</p>
            <p>2.1 对制度稽查不予配合或配合不力的；</p>
            <p>2.2 对前次检查需整改项经整改后仍不符要求的；</p>
            <p>2.3 未在指定时间列出整改计划或整改计划不符要求的；</p>
            <p>2.4 被稽查部门就同一问题，两次未按要求整改或整改不力的，将对责任人最高考核500分；</p>
            <p>3、稽查小组如违反公平、公正、公开原则，存在瞒报漏报情况并经管理公司总经理确认的，应对相关人员予以对应稽查项目考核标准的加倍处罚。</p>
            <h4>本《内部管控稽查制度》自下发之日起实施。</h4>


        </div>
    </div>
;

export default Section$;